"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class PastPapersDoNotExistError extends client_library_1.ExtendableError {
    constructor(courseId) {
        super(`No past papers found for course with id: ${courseId}`);
        this.courseId = courseId;
    }
}
exports.default = PastPapersDoNotExistError;
//# sourceMappingURL=PastPapersDoNotExistError.js.map